import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';

import { BehaviorSubject, Observable } from 'rxjs';

import { environment } from 'environments/environment';
import { AuthenticationService } from '../authentication/authentication.service';
import { Counterparty } from './counterparty';

@Injectable()
export class CounterpartyService implements Resolve<any> {
  public rows: any;
  public onCounterpartyListChanged: BehaviorSubject<any>;

  constructor(private _httpClient: HttpClient, public _authenticationService: AuthenticationService) {
    this.onCounterpartyListChanged = new BehaviorSubject({});
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
    return new Promise<void>((resolve, reject) => {
      Promise.all([this.getAllCounterparties()]).then(() => {
        resolve();
      }, reject);
    });
  }

  getAllCounterparties(ignoreSubjects = false): Promise<Counterparty[]> {
    const headers = this._authenticationService.getAccessTokenHeader();
    return new Promise((resolve, reject) => {
      this._httpClient.get(`${environment.apiUrl}/v1/counterparties`, { headers }).subscribe((response: any) => {
        this.rows = response.results;
        if (!ignoreSubjects) {
          this.onCounterpartyListChanged.next(this.rows);
        }
        resolve(this.rows);
      }, reject);
    });
  }

  createCounterparty(counterparty): Promise<void> {
    delete counterparty.id;
    const headers = this._authenticationService.getAccessTokenHeader();
    return new Promise((resolve, reject) => {
      this._httpClient.post(`${environment.apiUrl}/v1/counterparties`, counterparty, { headers }).subscribe((response: any) => {
        this.getAllCounterparties();
        resolve();
      }, reject);
    });
  }

  updateCounterparty(counterparty): Promise<void> {
    delete counterparty.ownedBy;
    const headers = this._authenticationService.getAccessTokenHeader();
    return new Promise((resolve, reject) => {
      this._httpClient.patch(`${environment.apiUrl}/v1/counterparties/${counterparty.id}`, counterparty, { headers }).subscribe((response: any) => {
        this.getAllCounterparties();
        resolve();
      }, reject);
    });
  }
}
